<template>
  <section class="content">
    <div class="row center-block">
      <div
        v-if="getRoleType === 99"
        class="col-xs-12 p-x-0 m-b-10 flex align-center"
      >
        <router-link :to="{
          name: goBackInfo.name,
          params: goBackInfo.params,
          query: goBackInfo.query
        }">
          <div class="btn btn-default m-r-5 flex">
            <span>返回</span>
            <span v-text="goBackInfo.title" />
            <span v-text="goBackInfo.subtitle" />
          </div>
        </router-link>
        <div class="flex grey darken-1">
          <div
            v-if="brand.name || store.brand_name"
            class="m-r-5"
            v-text="brand.name ? brand.name : store.brand_name ? store.brand_name : ''"
          />
          <div
            v-if="store.name"
            class="m-r-5"
            v-text="'/'"
          />
          <div
            v-if="store.name"
            v-text="store.name"
          />
        </div>
      </div>
      <div class="col-md-12">
        <div class="box">
          <div class="box-header">
            <h5>
              <span class="text-red">＊</span>
              如需新增、修改菜單內容，請至
              <router-link
                :to="{
                  name: goStepViewInfo.name,
                  params: goStepViewInfo.params
                }"
                v-text="goStepViewInfo.title"
              />
            </h5>
          </div>
          <!-- /.box-header -->
          <div class="box-body">
            <div class="form-inline">
              <div class="row">
                <div class="col-sm-8 text-left">
                  <div class="form-group text-left">
                    <div
                      class="btn btn-default btn-table-title"
                      @click="goToCrMenu"
                    >
                      新增菜單
                    </div>
                  </div>
                  <div
                    v-if="!isStore"
                    class="form-group text-left"
                  >
                    <router-link :to="{
                      name: 'crStoreClass',
                      params: {
                        brand_id: $route.params.brand_id
                      }
                    }">
                      <div class="btn btn-default btn-table-title">
                        門市群組
                      </div>
                    </router-link>
                  </div>
                  <div
                    v-if="!isStore"
                    class="form-group text-left"
                  >
                    <router-link :to="{
                      name: 'MenuSettingRuleStoreCopyView',
                      params: {
                        brand_id: $route.params.brand_id
                      }
                    }">
                      <div class="btn btn-default btn-table-title">菜單同步權限設定</div>
                    </router-link>
                  </div>
                  <div
                    v-if="!isStore"
                    class="form-group text-left"
                  >
                    <router-link :to="{
                      name: 'MenuSettingRuleStoreUpdateView',
                      params: {
                        brand_id: $route.params.brand_id
                      }
                    }">
                      <div class="btn btn-default btn-table-title">菜單編輯權限設定</div>
                    </router-link>
                  </div>
                </div>
                <div class="col-sm-4 text-right">
                  <div class="form-group">
                    <select class="form-control h-38">
                      <option value="1">代碼</option>
                      <option value="2">時間</option>
                    </select>
                  </div>
                  <div class="form-group search-bar">
                    <div class="input-group">
                      <input class="form-control" type="text">
                      <span class="input-group-addon c-pointer"><i class="fa fa-search"></i></span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-sm-12 table-responsive p-x-0">
                  <table
                    v-if="menuList.length"
                    class="table table-bordered table-striped dataTable"
                  >
                    <thead>
                      <tr role="row">
                        <th>#</th>
                        <th>菜單ID</th>
                        <th>名稱</th>
                        <th>版本碼</th>
                        <th>描述</th>
                        <th>備註</th>
                        <th>鎖定</th>
                        <th>狀態</th>
                        <th>版本時間</th>
                        <th>修改時間</th>
                        <th>建立時間</th>
                        <th></th>
                        <th></th>
                        <th></th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(menu, index) in menuList"
                        :key="index"
                      >
                        <td>
                          <button
                            class="btn btn-primary"
                            @click="goToMenuInfo(menu.menu_id)"
                          >
                            <i class="fa fa-bars" aria-hidden="true" />
                            <span v-text="index + 1" />
                          </button>
                        </td>
                        <td v-text="menu.menu_id" />
                        <td v-text="menu.name" />
                        <td v-text="menu.ver_stamp" />
                        <td v-text="menu.description" />
                        <td v-text="menu.remark" />
                        <td>
                          <span v-if="!menu.is_locked" class="label label-success">開啟</span>
                          <span v-if="menu.is_locked"  class="label label-danger">鎖定</span>
                        </td>
                        <td>
                          <span v-if="menu.status == 1" class="label label-danger">編輯中</span>
                          <span v-if="menu.status == 2"  class="label label-success">編輯完畢</span>
                        </td>
                        <td v-text="menu.ver_time" />
                        <td v-text="menu.update_time" />
                        <td v-text="menu.create_time" />

                        <!-- lock -->
                        <td>
                          <button
                            v-if="menu.is_locked"
                            class="btn btn-default"
                            @click="menuUnlock(menu.menu_id)"
                          >
                            <i
                              class="fa fa-lock"
                              aria-hidden="true"
                            />
                          </button>
                          <button
                            v-if="!menu.is_locked && menu.status === 2"
                            class="btn btn-default"
                            @click="menuLock(menu.menu_id)"
                          >
                            <i
                              class="fa fa-unlock-alt"
                              aria-hidden="true"
                            />
                          </button>
                        </td>
                        <!-- End lock -->

                        <!-- 編輯 -->
                        <td>
                          <button
                            v-if="!menu.is_locked"
                            class="btn btn-default"
                            @click="goToUpMenu(menu.menu_id)"
                          >
                            <i class="fa fa-pencil" aria-hidden="true" />
                          </button>
                        </td>
                        <!-- End 編輯 -->

                        <!-- 複本 -->
                        <td>
                          <button
                            v-if="menu.status == 2"
                            class="btn btn-primary"
                            @click="goToCrMenu({ menu, type: 1 }, 1111)"
                            v-text="'複本'"
                          />
                        </td>
                        <!-- End 複本 -->

                        <!-- 上架 -->
                        <td>
                          <button
                            v-if="menu.is_locked"
                            class="btn bg-black"
                            @click="goToCrSchedule(menu)"
                            v-text="'上架'"
                          />
                        </td>
                        <!-- End 上架 -->
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div class="col-xs-12 text-center">
                  <ul class="pagination">
                    <li class="paginate_button" v-if="pageAmount > 1 && pageGroup !== 1" @click="pageGroup = pageGroup - 1">
                      <a class="c-pointer"><i class="fa fa-angle-double-left" aria-hidden="true"></i></a>
                    </li>
                    <li class="paginate_button" v-for="index in pageAmount" :class="{active: isActive(index)}" @click="getMenuList(index)" v-if="pageShow(index)">
                      <a class="c-pointer">{{index}}</a>
                    </li>
                    <li class="paginate_button" v-if="pageAmount > 1 && pageAmount / groupAmount > pageGroup" @click="pageGroup = pageGroup + 1">
                      <a class="c-pointer"><i class="fa fa-angle-double-right" aria-hidden="true"></i></a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <!-- /.box-body -->
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import 'datatables.net'
import 'datatables.net-bs'
import NdExtendHandleMenu from '@/extends/nd-extend-handle-menu.vue'

export default {
  name: 'MenuBuild',
  data () {
    return {
      name: '迷客夏',
      tableIndex: 1,
      pageGroup: 1,
      groupAmount: 10,
      count: 20,
      menuList: [],
      maxTotal: 0
    }
  },
  extends: NdExtendHandleMenu,
  computed: {
    ...mapGetters(['getRoleType']),
    getDataH () {
      return this.$parent.getDataH
    },
    pageAmount () {
      return Math.ceil(this.maxTotal / this.count)
    },
    goStepViewInfo () {
      let name = ''
      let params = {}
      let query = {}
      let title = ''
      if (this.isStore && this.getRoleType !== 10) {
        switch (this.$route.name) {
          case 'StoreMenuBuild':
            name = 'StoreMenuStep'
            params.brand_id = this.$route.params.brand_id
            params.store_id = this.$route.params.store_id
            title = '配料庫'
            break
          default:
            console.log('default')
            break
        }
      } else {
        name = 'brandMenu'
        params.brand_id = this.$route.params.brand_id
        title = '配料庫'
      }
      return {
        name,
        params,
        query,
        title
      }
    }
  },
  created () {
    this.getMenuList()
  },
  mounted () {
    this.getExtendHandleMenuInfo()
  },
  methods: {
    isActive (index) {
      if (this.tableIndex === index) return true
      else return false
    },
    getMenuList (index) {
      if (index) this.tableIndex = index
      const url = this.base + this.id + '/menu/list?size=' + this.count + '&page=' + this.tableIndex
      this.getDataH('get', url, null, (response) => {
        if (response.data.status === 200) {
          this.maxTotal = response.data.meta.total
          this.menuList = response.data.menu_list
        }
      })
    },
    goToCrSchedule (menu) {
      console.log('goToCrSchedule')
      let name = ''
      let params = {
        brand_id: this.$route.params.brand_id,
        menu_id: menu.menu_id,
        store_id: ''
      }
      let query = {
        menu_name: menu.name
      }

      if (this.isStore && this.getRoleType !== 10) {
        name = 'StoreMenuScheduleCreate'
        params.store_id = this.$route.params.store_id
      } else {
        name = 'crSchedule'
      }

      this.$router.push({ name, params, query })
    },
    /**
     * 前往建立菜單
     *
     * @param {object} menu 菜單資訊
     * @param {number} type 0: 新增菜單, 1: 複本菜單
     */
    goToCrMenu ({ menu = {}, type = 0 } = {}, test = 0) {
      console.log('goToCrMenu')
      let name = ''
      let params = {
        brand_id: this.$route.params.brand_id,
        store_id: ''
      }

      let query = {}
      if (type === 1) {
        query.copy_menu_id = menu.menu_id
      }

      if (this.isStore && this.getRoleType !== 10) {
        name = 'StoreMenuBuildCreate'
        params.store_id = this.$route.params.store_id
      } else {
        name = 'crMenu'
      }

      this.$router.push({ name, params, query })
    },
    goToMenuInfo (menuId = 0) {
      console.log('goToMenuInfo')
      let name = ''
      let params = {
        brand_id: this.$route.params.brand_id,
        menu_id: menuId,
        store_id: ''
      }

      if (this.isStore && this.getRoleType !== 10) {
        name = 'StoreMenuInfo'
        params.store_id = this.$route.params.store_id
      } else {
        name = 'menuInfo'
      }

      this.$router.push({ name, params })
    },
    goToUpMenu (menuId = 0) {
      console.log('goToUpMenu')
      let name = ''
      let params = {
        brand_id: this.$route.params.brand_id,
        menu_id: menuId,
        store_id: ''
      }

      if (this.isStore && this.getRoleType !== 10) {
        name = 'StoreMenuEdite'
        params.store_id = this.$route.params.store_id
      } else {
        name = 'upMenu'
      }

      this.$router.push({ name, params })
    },
    menuUnlock (menuId) {
      const url = this.base + this.id + '/menu/' + menuId + '/unlock'
      this.getDataH('put', url, null, (response) => {
        if (response.data.status === 200) {
          this.$notify({
            title: '訊息',
            text: '成功解除菜單鎖定',
            duration: 3000,
            type: 'success',
            width: 400
          })
          this.getMenuList()
        }
      })
    },
    menuLock (menuId) {
      const url = this.base + this.id + '/menu/' + menuId + '/lock'
      this.getDataH('put', url, null, (response) => {
        if (response.data.status === 200) {
          this.$notify({
            title: '訊息',
            text: '成功鎖定菜單',
            duration: 3000,
            type: 'success',
            width: 400
          })
          this.getMenuList()
        }
      })
    },
    pageShow (index) {
      const num = index / this.groupAmount
      if (this.pageGroup - 1 < num && num <= this.pageGroup) return true
      else return false
    }
  }
}
</script>



// WEBPACK FOOTER //
// menu-build.vue?52f67e6f